/**
 * @function
 * @name Day 
 * @param {OBJECT} props 
 * @extends React
 */
export default function Day(props) {
    let { newDate, setDate, currentMonth, controllers, setHover,inputDate } = props;
    let enablePast =  props.enablePast;
    let enableFuture = props.enableFuture ;
    let disableDay = props.disableDay; 
    
    /**
     * @function
     * @memberof Day
     * @returns BOOLEAN - returns true if the day is in the currentMonth and is the selected day
     */
    function selected() {
        return newDate.isEqual(setDate) && (currentMonth.monthInt == newDate.monthInt) && inputDate !== "";
    }
    
    /**
     * @function
     * @memberof Day 
     * @returns BOOLEAN - returns true if the day is in past and not part of current month
     */
    function disabled() {
        /*const pastValid = (enablePast ? !newDate.isPast() : newDate.isPast()) && !newDate.isToday();
        const futureValid = (enableFuture ? !newDate.isFuture() : newDate.isFuture()) && !newDate.isToday();
        const dayValid = disableDay(newDate);*/

        let pastValid = false,
            futureValid = false,
            dayValid = disableDay(newDate);

        if(newDate.isPast()) {
            pastValid = (enablePast ? !newDate.isPast() : newDate.isPast()) && !newDate.isToday();
        }
        if(newDate.isFuture()) {
            futureValid = (enableFuture ? !newDate.isFuture() : newDate.isFuture()) && !newDate.isToday();
        }

        return (pastValid || futureValid || dayValid) || newDate.monthInt !== currentMonth.monthInt;
    }

    /**     
     * @memberof Day 
     * @function    
     * @param {OBJECT} event the click event for the day 
     * @returns VOID
     */
    function onClick(event) {
        if (disabled() === false) {
            props.onChange(newDate)
            controllers.close();
        }
    }

    /**     
     * @memberof Day
     * @function     
     * @param {OBJECT} event mouse in event
     * @returns VOID  
     */
    function mouseIn(event) {
        if (disabled() === false) {
            setHover(newDate)
        }
    }

    /**    
     * @memberof Day
     * @function    
     * @param {OBJECT} event mouse in event
     * @returns VOID    
     */
    function mouseOut(event) {        
        setHover(setDate)       
    }

    let className = (newDate.isToday() ? "current-day " : "") + (selected() ? "selected " : " ") + "week-day flex-width" + (disabled() ? " grey " : " ");
    className =  newDate.isWeekend() ? `${ className }weekend` : className;

    return (
        <span className={ className } onMouseEnter={mouseIn} onMouseLeave={mouseOut} onClick={onClick}>
            <span data-point={"date_select_"+newDate.diff(setDate)} className={"day-number"}>{newDate.dayInt}</span>
        </span>
    )
}
